
import { createApp } from 'vue'
import App from './App.vue'
import 'windi.css'
import router from '../../router'
import store, { key } from '../../store'
import Antd from 'ant-design-vue'
import VueFullPage from 'vue-fullpage.js'
import 'ant-design-vue/dist/antd.css'
import '@/style/common.scss'
import 'vue-fullpage.js/dist/style.css'

// import './fullpage.scrollHorizontally.min' // Optional. When using fullpage extensions
window.EDITOR_URL = `https://${/^uat-/.test(location.hostname) ? 'uat-' : ''}s1.hdslb.com/bfs/static/studio/static/doc-it/v2/editor.md`

const loadDocStyle = () => {
  const styleNode = document.createElement('link')
  styleNode.setAttribute('rel', 'stylesheet')
  styleNode.setAttribute('type', 'text/css')
  styleNode.setAttribute('href', `${window.EDITOR_URL}/css/editormd.preview.min.css`)
  document.getElementsByTagName('head')[0].appendChild(styleNode)
}
loadDocStyle()
;(async () => {
  const app = createApp(App)
  app.use(store, key).use(router).use(Antd).use(VueFullPage).mount('#app')
})()
